import React, { ReactNode } from "react";
import { StripeElementsConfig } from "./components/StripeElementsConfig";
import { PaymentManagementAddOrEdit } from "./components/PaymentManagementAddOrEdit";

export type PaymentManagementProps = {
  stripeCustomerId: string;
  onError: (error: any) => void;
  onSelectPaymentMethod: (paymentMethodId: string) => void;
};

const PaymentManagement = ({ children }: { children: ReactNode }) => ({
  children,
});

const AddOrEdit = ({
  stripeCustomerId,
  onError,
  onSelectPaymentMethod,
}: PaymentManagementProps) => (
  <StripeElementsConfig customerId={stripeCustomerId}>
    <PaymentManagementAddOrEdit
      stripeCustomerId={stripeCustomerId}
      onError={onError}
      onSelectPaymentMethod={onSelectPaymentMethod}
    />
  </StripeElementsConfig>
);

export default { PaymentManagement, AddOrEdit };
